import { trackButtonClick } from "./track";
import { resolvePageKeyFromPath } from "./routeMap";

const BUTTON_SELECTORS = [
  "button:not([disabled])",
  'input[type="button"]:not([disabled])',
  'input[type="submit"]:not([disabled])',
  '[role="button"]:not([aria-disabled="true"])',
  "a.ant-btn:not(.ant-btn-disabled)",
  "button.ant-btn:not(.ant-btn-disabled)",
  "[data-behavior-button-id]",
].join(",");

const SKIP_SELECTOR = "[data-behavior-no-track]";

let bound = false;

function slugifyId(raw) {
  const slug = String(raw || "")
    .trim()
    .slice(0, 64)
    .replace(/\s+/g, "_")
    .replace(/[^\w\-_.:/]/gi, "")
    .toLowerCase();
  return slug || "unknown_button";
}

function isDisabled(el) {
  if (!el) return true;
  if (el.disabled) return true;
  if (el.getAttribute("aria-disabled") === "true") return true;
  if (el.classList?.contains("ant-btn-disabled")) return true;
  return false;
}

function resolveButtonId(el) {
  const explicit = el.getAttribute("data-behavior-button-id");
  if (explicit) return slugifyId(explicit);

  const testId = el.getAttribute("data-testid");
  if (testId) return slugifyId(testId);

  if (el.id) return slugifyId(el.id);
  if (el.name) return slugifyId(el.name);

  const aria = el.getAttribute("aria-label");
  if (aria) return slugifyId(aria);

  const text = (el.textContent || el.innerText || "").replace(/\s+/g, " ").trim();
  if (text) return slugifyId(text);

  const cls =
    el.className && typeof el.className === "string"
      ? el.className.split(/\s+/).find((c) => c && !/^ant-/.test(c))
      : "";
  return slugifyId(`${el.tagName.toLowerCase()}${cls ? `_${cls}` : ""}`);
}

function resolveFeature(el, pageKey) {
  const explicit = el.getAttribute("data-behavior-feature");
  if (explicit) return explicit;
  return pageKey || "general";
}

function shouldSkip(el) {
  if (!el || isDisabled(el)) return true;
  if (el.closest(SKIP_SELECTOR)) return true;
  if (typeof window !== "undefined") {
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return true;
  }
  return false;
}

function findButton(target) {
  if (!target || !(target instanceof Element)) return null;
  const el = target.closest(BUTTON_SELECTORS);
  if (!el || shouldSkip(el)) return null;
  return el;
}

function getPagePath() {
  if (typeof window === "undefined") return "";
  return `${window.location.pathname}${window.location.search}`;
}

function handleDocumentClick(event) {
  const button = findButton(event.target);
  if (!button) return;

  const pagePath = getPagePath();
  const pageKey = resolvePageKeyFromPath(pagePath);

  trackButtonClick({
    buttonId: resolveButtonId(button),
    feature: resolveFeature(button, pageKey),
    pagePath,
    pageKey: pageKey || undefined,
  });
}

/** 全局委托：自动上报 PRD button_click */
export function bindAutoButtonClickTracking() {
  if (bound || typeof document === "undefined") return;
  bound = true;
  document.addEventListener("click", handleDocumentClick, true);
}

export function unbindAutoButtonClickTracking() {
  if (!bound || typeof document === "undefined") return;
  bound = false;
  document.removeEventListener("click", handleDocumentClick, true);
}
